document.addEventListener("DOMContentLoaded", (event) => {
    $(".prim-btn").click(function () {
      $(this).addClass("loading");
      const selectedProduct = $(this).attr("data-id");
      let formData = {
        items: [
          {
            id: selectedProduct,
            quantity: 1,
          },
        ],
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);
          window.location.href = "/cart";
        })
        .catch((error) => {
          console.error("Error:", error);
        });

      setTimeout(() => {
        $(this).removeClass("loading");
      }, 1000);
    });


  setTimeout(() => {
    document
      .querySelector("span.deferred-media__poster-button.motion-reduce")
      .click();
  }, 1000);

  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // document.addEventListener("scroll", (event) => {
  //   const elem = document.querySelector(".custom_slide");
  //   const addClass = document.querySelector(".moving-slider-vr");
  //   if (isInViewport(addClass)) {
  //     elem.classList.add("fixedTop");
  //   } else {
  //     elem.classList.remove("fixedTop");
  //   }
  // });
});
